<app-particles></app-particles>
<main (click)="tapScreen()" [class.block]="step==50">
  <app-finish [active]="step > 1" (clicked)="reloadExperience()"></app-finish>
  <app-step1 *ngIf="step == 1" [logo]="logoUrl" [welcomeText]="welcomeText"/>
  <app-step2-search *ngIf="step==2" (productSelected)="onProductSelected($event, 2)" (stageCompleted)="onStageCompleted(2)" (error)="onError($event)"></app-step2-search>
  <app-step3-upsell *ngIf="step==3" (productSelected)="onProductSelected($event, 3)" (stageCompleted)="onStageCompleted(3)" #upsellComponent></app-step3-upsell>
  <app-step4-xsell *ngIf="step==4" (productSelected)="onProductSelected($event, 4)" (stageCompleted)="onStageCompleted(4)" #xsellComponent></app-step4-xsell>
  <app-step5-cart *ngIf="step==5" (finish)="onNext()" (addMore)="onAddMore()"></app-step5-cart>
  <app-step6-payment *ngIf="step==6" (next)="onNext()" (previous)="step = 5"></app-step6-payment>
  <app-step7-ticket *ngIf="step==7"></app-step7-ticket>
</main>
<footer *ngIf="step == 1">
  Virtual-Seller | www.tercerpiso.net
</footer>


<div class="cortina-loader" [class.inactive]="!loadingEnvironment">
  <span class="loader" *ngIf="!envError"></span>
  <span class="text" *ngIf="!envError && loadingText">Cargando entorno virtual...</span>
  <span class="error" *ngIf="envError">{{envError}}</span>
</div>
